const distributorNetwork = {
  init() {
    const picker = document.querySelector('[data-distributor-picker]');
    const regionsContainer = document.querySelector('[data-distributor-regions]');
    if (!picker || !regionsContainer) return;

    const regions = regionsContainer.querySelectorAll('[data-distributor-region]');
    if (regions.length === 0) return;

    const showRegion = (id) => {
      regions.forEach((region) => {
        if (region.id === id) {
          region.removeAttribute('hidden');
        } else {
          region.setAttribute('hidden', '');
        }
      });
    };

    picker.addEventListener('change', (event) => {
      showRegion(event.target.value);
    });

    showRegion(picker.value);
  },
};

export default distributorNetwork;

distributorNetwork.init();
